import request from '@/utils/request'
import URL from '@/api/urlTranslator'
import $store from '@/store'

// FBA查询列表
export function queryFbaJobList(requestBody) {
  return request({
    url: URL.fba.queryFbaJobList,
    method: 'post',
    data: requestBody
  })
}

// 保存FBA信息
export function saveFbaJob(requestBody) {
  return request({
    url: URL.fba.saveFbaJob,
    method: 'post',
    data: requestBody
  })
}

// 保存复制业务
export function saveCopyJob(requestBody) {
  return request({
    url: URL.fba.saveCopyJob,
    method: 'post',
    data: requestBody
  })
}

// 审核通过
export function approved(data, officeId) {
  return request({
    url: URL.fba.approved,
    method: 'post',
    data,
    params: { officeId }
  })
}

// 获取FBA信息
export function getFbaJob(requestBody) {
  return request({
    url: URL.fba.getFbaJob,
    method: 'post',
    data: requestBody
  })
}

// 复制FBA业务
export function doCopyFbaJob(data) {
  return request({
    url: URL.fba.doCopyFbaJob,
    method: 'post',
    data
  })
}

// 批量修改暂不提交和/提交状态
export function updNotSubmitOrSubmit(requestBody) {
  if (!requestBody.branchId) { // 将当前分公司传到后端
    requestBody.branchId = $store.getters.currentOfficeId
  }
  return request({
    url: URL.fba.updNotSubmitOrSubmit,
    method: 'post',
    data: requestBody
  })
}

// 删除FBA下单
export function fbaBatchRemove(requestBody) {
  return request({
    url: URL.fba.fbaBatchRemove,
    method: 'delete',
    data: requestBody
  })
}

// FBA保存收发通地址
export function saveBillAddress(requestBody) {
  return request({
    url: URL.fba.saveBillAddress,
    method: 'post',
    data: requestBody
  })
}

// FBA发送分公司保存复制业务
export function fbaSaveCloneJob(requestBody) {
  return request({
    url: URL.fba.saveCloneJob,
    method: 'post',
    data: requestBody
  })
}

// FBA根据业务编号查询业务
export function fbaGetRelatedJob(jobNo) {
  return request({
    url: URL.fba.getRelatedJob,
    method: 'get',
    params: { jobNo }
  })
}
